import store from '../../store/store';

export default (to, from, next) => {
	if (!store.getters['auth/loggedIn']) {
		store.dispatch('auth/logout');
		return next('/login');		
	}

	if(!store.getters['auth/user'].accepted_dsgvo || !store.getters['auth/user'].accepted_terms_of_service) {
		return next('/app/dashboard');
	}

	return next();
}